import { useEffect } from "react";
import styled from "styled-components";
import { API_LOAN_PRODUCTS } from "../../../constants/apis";
import { INVEST, INVESTMENT_PLANS } from "../../../constants/constants";
import useGet from "../../../hooks/common/useGet";
import { useTitle } from "../../../hooks/common/useTitle";
import { InvestmentPlanItem } from "../../../hooks/investments/useInvestmentPlansList";
import { stringify } from "../../../utils/helpers";
import { Loader } from "../../common/Loader";
import { AnimateChildren, EmptyView, Heading } from "../../elements/Elements";
import { IsBorrower } from "../../../utils/permissionUtils";
import { Link } from "react-router-dom";
import { Button } from "../../common/Button";

export const InvestPage = () => {
  useTitle(INVEST);

  const { loadData, loading, data } = useGet();
  const listData = data?.results || [];
  const isBorrower = IsBorrower();

  useEffect(() => {
    if (!isBorrower) {
      loadData({ api: API_LOAN_PRODUCTS });
    }
  }, []);

  // Borrowers cannot invest
  if (isBorrower) {
    return (
      <div className="vh100Min flexCenter">
        <div className="textCenter flexColumn gap15 p30">
          <div className="font40">🔒</div>
          <div className="font18 bold textDark">Investor Access Only</div>
          <div
            className="font13 grey"
            style={{ maxWidth: 350, lineHeight: 1.6 }}
          >
            Investment features are available to lender/investor accounts only.
            As a borrower you can apply for loans and finance devices.
          </div>
          <Link to="/">
            <Button>Go to Dashboard</Button>
          </Link>
        </div>
      </div>
    );
  }

  if (loading)
    return (
      <div className="vh100Min flexCenter">
        <Loader />
      </div>
    );

  if (listData.length === 0)
    return (
      <div className="vh100Min flexCenter">
        <EmptyView source={INVESTMENT_PLANS} />
      </div>
    );

  return (
    <div className="p15 flexColumn gap15">
      <AnimateChildren>
        <div>
          <Heading>{stringify(INVESTMENT_PLANS)}</Heading>
          <div className="grey font12">
            Browse vetted loans and earn competitive returns
          </div>
        </div>

        <GridWrapper>
          {listData.map((v: any, i: number) => (
            <InvestmentPlanItem data={v} key={i} />
          ))}
        </GridWrapper>
      </AnimateChildren>
    </div>
  );
};

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;